import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiAuthenticateHelperService } from '@fi-shared/fi-auth-shared/fi-authenticate-helper.service';
import { FiAuthChangeLoginService } from '@fi-shared/fi-auth-shared/fi-auth-change-login.service';
import { FiUserEmailInconsistentDialogComponent } from './fi-user-email-inconsistent-dialog/fi-user-email-inconsistent-dialog.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { FormsModule } from '@angular/forms';
import { MatRadioModule } from '@angular/material/radio';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FiErrorMessageModule } from '@fi-shared/fi-error-message';
import { FiCustomValidatorsModule } from '@fi-shared/fi-directives/fi-custom-validators/fi-custom-validators.module';
import { MatInputModule } from '@angular/material/input';
import { FiValidatingFormModule } from '@fi-shared/fi-directives/fi-validating-form/fi-validating-form.module';

@NgModule({
    imports: [
        CommonModule,
        MatCheckboxModule,
        FiAppTextSharedModule,
        FormsModule,
        MatRadioModule,
        MatFormFieldModule,
        MatInputModule,
        FiErrorMessageModule,
        FiCustomValidatorsModule,
        FiValidatingFormModule,
    ],
    declarations: [FiUserEmailInconsistentDialogComponent],
    providers: [FiAuthenticateHelperService, FiAuthChangeLoginService],
})
export class FiAuthSharedModule {}
